import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { ArrowDownCircle, ArrowUpCircle } from 'lucide-react';
import { FINANCIAL_ENTRY_TYPE } from '../constants';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Wrapper = styled.div`
  background: #fff;
  border-radius: 12px;
  width: min(440px, calc(100vw - 32px));
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: 'Inter', sans-serif;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 1.05rem;
  color: #111827;
`;

const Subtitle = styled.p`
  margin: 0;
  font-size: 0.85rem;
  color: #6b7280;
`;

const Options = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

const OptionButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px 12px;
  border: 1.5px solid #d1d5db;
  border-radius: 12px;
  background: #fff;
  color: #374151;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;

  &:hover {
    border-color: #0090d3;
    background: #e0f0fa;
    color: #0090d3;
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const CancelButton = styled.button`
  height: 38px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #374151;
  font-size: 0.9rem;
  cursor: pointer;
`;

interface SelectEntryTypeModalProps {
  onClose: () => void;
  onSelect: (type: number) => void;
}

const SelectEntryTypeModal: React.FC<SelectEntryTypeModalProps> = ({
  onClose,
  onSelect,
}) => {
  return ReactDOM.createPortal(
    <Overlay onClick={onClose}>
      <Wrapper onClick={(event) => event.stopPropagation()}>
        <div>
          <Title>Novo lançamento</Title>
          <Subtitle>
            O tipo define quem é o pagador e quem é o recebedor, e pode ser
            alterado depois no formulário.
          </Subtitle>
        </div>

        <Options>
          <OptionButton
            type="button"
            onClick={() => onSelect(FINANCIAL_ENTRY_TYPE.REVENUE)}
          >
            <ArrowDownCircle size={28} />
            Entrada
          </OptionButton>
          <OptionButton
            type="button"
            onClick={() => onSelect(FINANCIAL_ENTRY_TYPE.EXPENSE)}
          >
            <ArrowUpCircle size={28} />
            Saída
          </OptionButton>
        </Options>

        <Footer>
          <CancelButton type="button" onClick={onClose}>
            Cancelar
          </CancelButton>
        </Footer>
      </Wrapper>
    </Overlay>,
    document.body,
  );
};

export default SelectEntryTypeModal;
